import axios from 'axios';
import { disablePushNotifications } from '../../utils/pushNotification';

const BASE_URL = process.env.REACT_APP_API_ENDPOINT;

const handleLogout = () => {
    localStorage.removeItem('currentUser')
    localStorage.removeItem('token')
    localStorage.removeItem('tabIndex')
    localStorage.clear();
    // Redirect to login page
    window.location.href = '/';
};

const api = axios.create({
    baseURL: BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add a request interceptor
api.interceptors.request.use(
    (config) => {
        // Get the token from localStorage
        const token = localStorage.getItem('token');

        // If the token exists, add it to the headers
        if (token) {
            config.headers.authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => {
        // Handle the error
        return Promise.reject(error);
    }
);

const handle401Error = (error) => {
    if (error.response && error.response.status === 401) {
        handleLogout();
    }
    return Promise.reject(error);
};

// Add response interceptor to api instance
api.interceptors.response.use(
    (response) => response,
    handle401Error
);

const LogOutHandler = {
    async doHandelLogOut(payload) {
        // const params = new URLSearchParams(payload).toString(); // Convert payload to query params

        try {
            // Dropped before the session ends, so a later account does not inherit this browser's pushes.
            await disablePushNotifications();

            const data = await api.post(`${BASE_URL}auth/logout`, payload);
            // console.log(data);
            if (data?.data?.statusCode === 200 || data?.status === 200) {
                localStorage.removeItem('currentUser')
                localStorage.removeItem('token')
                localStorage.removeItem('tabIndex')
            }
            return data;
        } catch (error) {
            return error;
        }
    },
}

export default LogOutHandler